import Toast from 'src/components/common/Toast'
import i18n from 'src/i18n'
import { orderBy } from 'lodash'

export default function (raw) {
  let years
  let activeYear
  const bookLoaded = true
  const { currentChapters, deletedChapters } = raw

  if (!deletedChapters.length && !currentChapters.length) {
    Toast({
      message: i18n.t('book.emptyContent')
    })
  }
  try {
    currentChapters.map(item => {
      item.deleted = false
    })
    deletedChapters.map(item => {
      item.deleted = true
    })

    let chapters = currentChapters
    chapters = orderBy(chapters, ['month'], ['asc']) // 按照章节月份正序

    raw.chapters = chapters

    const timeLine = {} // 时间线数据源
    let pages = 3 // Turn 起始页数为 2
    chapters.map(item => {
      const year = item.month.substr(0, 4)
      const month = item.month.substr(4, 2)
      timeLine[year] = timeLine[year] || []
      timeLine[year].push(Object.assign(item, { month, time: item.month, pages }))
      // 书籍月份插页对应页数
      pages += item.totalPage + 1
    })
    // 将隐藏的月份也加入 timeLine，标记 deleted: true
    const sortedDeleted = orderBy(deletedChapters, ['month'], ['asc'])
    sortedDeleted.map(item => {
      const year = item.month.substr(0, 4)
      const month = item.month.substr(4, 2)
      timeLine[year] = timeLine[year] || []
      // 避免重复添加
      const exists = timeLine[year].find(m => m.time === item.month)
      if (!exists) {
        timeLine[year].push(Object.assign(item, { month, time: item.month, pages: 0 }))
      }
    })
    // 重新排序每年的月份
    Object.keys(timeLine).forEach(year => {
      timeLine[year] = orderBy(timeLine[year], ['time'], ['asc'])
    })
    raw.timeLine = timeLine
    years = Object.keys(timeLine).reverse()
    activeYear = years[0]
  } catch (err) {
    console.log(err)
  }
  const book = raw
  return { years, activeYear, book, bookLoaded }
}
